<template>
  <div class="content-wrapper">
    <vs-row class="my-4">
      <vs-col vs-lg="8" vs-sm="12">
        <vs-button
          :to="`/conferences/sponsors/add` + suffixParams"
          color="primary"
          type="filled"
          >Add New</vs-button
        >
      </vs-col>
      <vs-col vs-lg="4" vs-sm="12">
        <!--
        <div style="float: right">
          <vs-input
            id="search"
            class="inputx"
            placeholder="Search..."
            v-model="search"
            v-on:input="debounceInput"
          />
        </div>
        -->
      </vs-col>
    </vs-row>
    <vx-card>
      <b-table
        ref="table"
        style="min-height: 600px"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height: 600px">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>

        <template v-slot:cell(publish_status)="data">
          <vs-switch
            v-model="data.item.publish_status"
            icon-pack="feather"
            vs-icon="icon-check"
            @change="onStatusChanged(data.item)"
          />
        </template>

        <template v-slot:cell(featured_status)="data">
          <vs-switch
            v-model="data.item.featured_status"
            icon-pack="feather"
            vs-icon="icon-star"
            @change="onStatusChanged(data.item)"
          />
        </template>

        <template v-slot:cell(sponsor_logo)="data">
          <div style="width: 80px">
            <img :src="data.item.sponsor_logo" class="inline-img" />
          </div>
        </template>

        <template v-slot:cell(sponsor_name)="data">
          <div style="width: 250px">
            <strong>{{ data.item.sponsor_name }}</strong>
          </div>
        </template>

        <template v-slot:cell(date)="data">
          <strong>{{ data.item.date }}</strong>
        </template>

        <template v-slot:cell(action)="data">
          <vs-button @click="open(data.item)" color="primary" type="flat"
            >View</vs-button
          >
        </template>
      </b-table>
      <div class="mt-3 text-center">
        <vs-pagination
          :total="Math.ceil(totalRows / 30)"
          v-model="currentPage"
          prev-icon="arrow_back"
          next-icon="arrow_forward"
        ></vs-pagination>
        <div class="mt-3">{{ from }} to {{ to }} of {{ totalRows }} items</div>
      </div>
    </vx-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Service from "@/services";

export default {
  components: {},
  data: () => ({
    suffixParams: "",
    columns: [
      { label: "ID", key: "sponsor_id", sortable: false },
      { label: "Publish Status", key: "publish_status", sortable: false },
      { label: "Featured Status", key: "featured_status", sortable: false },
      {
        label: "Logo",
        key: "sponsor_logo",
        sortable: false,
        tdClass: "width-450",
      },
      {
        label: "Sponsor Name",
        key: "sponsor_name",
        sortable: false,
        tdClass: "width-450",
      },
      {
        label: "Weight",
        key: "weight",
        sortable: false,
        tdClass: "width-300",
      },
      { label: "", key: "action", tdClass: "width-300", sortable: false },
    ],
    search: "",
    filter: "",
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    isBusy: false,
    currentPage: 1,
    perPage: 30,
    totalRows: 0,
    selected: [],
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
  }),
  computed: {
    ...mapState({
      s: (state) => {
        return state.Utility.s;
      },
      e: (state) => {
        return state.Utility.e;
      },
    }),
  },
  created() {
    setTimeout(() => {
      this.suffixParams = "?s=" + this.s + "&e=" + this.e;
    }, 1000);
  },
  methods: {
    dataProvider(ctx, callback) {
      setTimeout(() => {
        this.isBusy = true;
        let data = {
          e: this.$route.query.e,
        };

        let params = Object.keys(data)
          .map((key) => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map((key) => key + "=" + ctx[key])
            .join("&");

        Service.Sponsor.gets(params)
          .then((res) => {
            this.isBusy = false;
            this.totalRows = res.data.total;
            this.from = res.data.from;
            this.to = res.data.to;
            this.data = res.data.rows;
            this.log = res.log;
            callback(this.data);
          })
          .catch((error) => {
            console.log(error);
            // Here we could override the busy state, setting isBusy to false
            // this.isBusy = false
            // Returning an empty array, allows table to correctly handle
            // internal busy state in case of error
            //return [];
            callback([]);
          });
        return null;
      }, 1000);
    },
    open(item) {
      this.$router.push(
        "/conferences/sponsors/" + item.sponsor_id + "/view" + this.suffixParams
      );
    },
    duplicate(item) {
      //this.$router.push("/conferences/sponsors/add?clone=" + item.e);
    },

    onStatusChanged: _.debounce(function (e) {
      let data = {
        e: this.e,
        sponsor_id: e.sponsor_id,
        publish_status: e.publish_status,
        featured_status: e.featured_status,
      };

      this.$vs.loading();
      Service.Sponsor.update(data).then((res) => {
        if (res.success) {
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success",
          });
        }

        this.$vs.loading.close();
      });
    }, 500),
  },
};
</script>